import React, {useState, useEffect} from "react";
import {Routes, Route, useNavigate, Navigate} from "react-router-dom";
import {jwtDecode} from "jwt-decode";
import {Layout, Menu, message, Modal} from "antd";
import {
    FileAddOutlined,
    CheckCircleOutlined,
    BarChartOutlined,
    LogoutOutlined,
    UserOutlined
} from "@ant-design/icons";
import Login from "./Login";
import UserProfile from "./UserProfile";
import DataEntry from "./DataEntry";
import Approvals from "./Approvals";
import Reports from "./Reports";
import Dashboard from "./Dashboard";
import "./timesheet.css";
import 'antd/dist/reset.css';
import AMNS_Logo from '../../../App/Assets/amns_india.jpg'

const {Header, Sider, Content} = Layout;

const Timesheet = () => {
    const navigate = useNavigate();
    const [token, setToken] = useState(sessionStorage.getItem("token"));
    const [user, setUser] = useState();
    const [collapsed, setCollapsed] = useState(false);
    const userRole = user?.role;

    useEffect(() => {
        if (token) {
            const userData = jwtDecode(token);
            setUser(userData);
        }
    }, [token]);

    const handleLogout = () => {
        Modal.confirm({
            title: "Confirm Logout",
            content: "Are you sure you want to log out?",
            okText: "Yes",
            cancelText: "Cancel",
            centered: true,
            okButtonProps: {
                danger: true,
            },
            onOk: () => {
                sessionStorage.removeItem("token");
                setToken(null);
                setUser(null);
                message.success("Logged out successfully");
            },
        });
    };

    const menuItems = [
        ...(userRole === "user"
            ? [{
                key: "/worksheet/profile",
                icon: <UserOutlined/>,
                label: "User Profile",
                path: "/worksheet/profile",
            }]
            : [{
                key: "/worksheet/dashboard",
                icon: <BarChartOutlined/>,
                label: "Dashboard",
                path: "/worksheet/dashboard",
            }]),
        ...(userRole === "user"
            ? [{
                key: "/worksheet/data-entry",
                icon: <FileAddOutlined/>,
                label: "Time Sheet",
                path: "/worksheet/data-entry",
            }]
            : ["manager", "admin"].includes(userRole)
                ? [{
                    key: "/worksheet/approvals",
                    icon: <CheckCircleOutlined/>,
                    label: "Approvals",
                    path: "/worksheet/approvals",
                }]
                : []),
        {
            key: "/worksheet/reports",
            icon: <BarChartOutlined/>,
            label: "Reports",
            path: "/worksheet/reports",
        },
        {
            key: "logout",
            icon: <LogoutOutlined/>,
            label: "Logout",
        }
    ];

    const handleMenuClick = (e) => {
        if (e.key === "logout") {
            handleLogout();
        } else {
            navigate(e.key);
        }
    };

    if (!token) {
        return (
            <div className="timesheet-wrapper">
                <Routes>
                    <Route path="/login" element={<Login setToken={setToken}/>}/>
                    <Route path="*" element={<Navigate to="/worksheet/login"/>}/>
                </Routes>
            </div>
        );
    }

    return (
        <div className="timesheet-wrapper">
        <Layout className="min-h-full max-h-full overflow-hidden">
            <Header className="bg-red-600 text-white h-14 shadow-sm flex items-center justify-between px-4">
                <div className="flex items-center space-x-2">
                    <img
                        src={AMNS_Logo}
                        style={{height: '40px', width: '75px', borderRadius: '5px'}}
                        draggable={false}
                        alt="AMNS Logo"
                    />
                    <span className="text-lg font-bold">WorkSheet</span>
                </div>
                <span className="text-lg font-semibold">
          Welcome, {user?.email}
        </span>
            </Header>

            <Layout className="flex-row overflow-hidden">
                <Sider collapsible collapsed={collapsed} onCollapse={setCollapsed}>
                    <Menu
                        theme="dark"
                        mode="inline"
                        selectedKeys={[window.location.pathname]}
                        items={menuItems}
                        onClick={handleMenuClick}
                    />
                </Sider>

                <Layout>
                    <Content className="p-6" style={{overflowY: 'auto', height: 'calc(100vh - 64px)'}}>
                        <Routes>
                            <Route path="/profile" element={<UserProfile user={user}/>}/>
                            <Route path="/dashboard" element={<Dashboard user={user}/>}/>
                            <Route path="/data-entry" element={<DataEntry user={user}/>}/>
                            <Route path="/approvals" element={<Approvals userId={user?.user_id}/>}/>
                            <Route path="/reports" element={<Reports user={user}/>}/>
                        </Routes>
                    </Content>
                </Layout>
            </Layout>
        </Layout>
        </div>
    );
}

export default Timesheet;